import { useSelector } from 'react-redux';

import { AppState } from 'state/types';

import {
  selectIsReadonlyDueToMonitoring,
  selectIsReadonlyDueToStorage,
  selectIsReadonlyDueToTrial,
  selectShowAdminMonitoringBanner,
  selectShowAdminStorageBanner,
  selectShowAdminTrialBanner,
} from './selectors';

export function useAdminBannersVisibility(organizationName: string) {
  const showTrialBanner = useSelector((state: AppState) =>
    selectShowAdminTrialBanner(state, organizationName),
  );
  const showMonitoringBanner = useSelector((state: AppState) =>
    selectShowAdminMonitoringBanner(state, organizationName),
  );
  const showStorageBanner = useSelector((state: AppState) =>
    selectShowAdminStorageBanner(state, organizationName),
  );

  const isReadonlyDueToTrial = useSelector((state: AppState) =>
    selectIsReadonlyDueToTrial(state, organizationName),
  );
  const isReadonlyDueToMonitoring = useSelector((state: AppState) =>
    selectIsReadonlyDueToMonitoring(state, organizationName),
  );
  const isReadonlyDueToStorage = useSelector((state: AppState) =>
    selectIsReadonlyDueToStorage(state, organizationName),
  );

  return {
    showAdminTrialErrorBanner: isReadonlyDueToTrial && showTrialBanner,
    showAdminMonitoringErrorBanner: isReadonlyDueToMonitoring && showMonitoringBanner,
    showAdminStorageErrorBanner: isReadonlyDueToStorage && showStorageBanner,
    showAdminTrialWarnBanner: !isReadonlyDueToTrial && showTrialBanner,
    showAdminMonitoringWarnBanner: !isReadonlyDueToMonitoring && showMonitoringBanner,
    showAdminStorageWarnBanner: !isReadonlyDueToStorage && showStorageBanner,
  };
}
